import angular from 'angular';
import assignmentsUnassignedComponent from './assignmentsUnassigned.component';

let assignmentsUnassignedModule = angular.module('assignmentsUnassigned', []).component('assignmentsUnassigned', assignmentsUnassignedComponent);

export default assignmentsUnassignedModule;



// WEBPACK FOOTER //
// ./app/components/assignmentsUnassigned/assignmentsUnassigned.js